export default __webpack_public_path__ + "static/media/Light_200by200.66060603.png";